import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireSuperAdmin } from "../../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/product-analytics/sessions/$sessionId")({
  beforeLoad: requireSuperAdmin(),
  component: () => <Outlet />,
});
